import findIndexByInstanceKey from '../actions/notifications/helpers/findIndexByInstanceKey';
import getAllTableViewsContainingItemsForFolder from '../utils/getAllTableViewsContainingItemsForFolder';
import TableOperations from 'owa-mail-list-table-operations';
import tombstoneOperations from 'owa-mail-list-tombstone';
import { actionNames } from 'owa-mail-store-actions';
import { getLastDeliveryTimeStamp } from 'owa-mail-list-store/lib/selectors/mailRowDataPropertyGetter';
import { MailListItemSelectionSource } from 'owa-mail-store';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
import { resetSelection } from 'owa-mail-actions';
/**
 * Subscribe the EmptyFolderStoreUpdate stitch and updates the list view store when the stitch is raised.
 */
export default function emptyFolderStitch() {
    subscribe(actionNames.EmptyFolderStoreUpdate, function (folder, clientSyncTime, deletedItemsFolderId, rowKeysToExclude) {
        var tableViewsForCurrentFolder = getAllTableViewsContainingItemsForFolder(folder.FolderId.Id, false /* shouldIncludeSearchTable */);
        // TODO: 1300 We need to find a way to invalidate tableView.lastEmptiedTime
        // in case something goes wrong with snapshot, etc.
        tableViewsForCurrentFolder.forEach(function (tableView) {
            // We need to wait to clear table view until AFTER
            // we have set last emptied time AND tombstoned.
            setLastEmptiedTime(tableView, rowKeysToExclude);
            tombstoneNotExcludedItems(tableView, rowKeysToExclude);
            TableOperations.clear(tableView, clientSyncTime /* skipRowsNewerThanTime */, rowKeysToExclude);
            // Update the tableView's total count
            tableView.totalRowsInView = tableView.rowKeys.length;
            // Reset selection for this folder.
            // VSO 13163 - Do not call resetSelection after data is removed in MultiSelectRP
            resetSelection(tableView, MailListItemSelectionSource.Reset);
        });
    });
}
// Set lastEmptiedTime on tableview
// Sets the value to the last delivery timestamp of oldest item in exclusion list if the list is not empty
// else sets current time
function setLastEmptiedTime(tableView, rowKeysToExclude) {
    var oldestItemDeliveryTimeStamp = null;
    if (rowKeysToExclude != undefined) {
        // Find item with oldest lastDeliveryTimeStamp
        for (var i = 0; i < rowKeysToExclude.length; i++) {
            var lastDeliveryTimeStamp = getLastDeliveryTimeStamp(rowKeysToExclude[i], tableView);
            if (oldestItemDeliveryTimeStamp == null ||
                new Date(lastDeliveryTimeStamp) < new Date(oldestItemDeliveryTimeStamp)) {
                oldestItemDeliveryTimeStamp = lastDeliveryTimeStamp;
            }
        }
    }
    // Set lastEmptiedTime to the timestamp of oldest item in exclusion list
    if (oldestItemDeliveryTimeStamp != null) {
        tableView.lastEmptiedTime = new Date(oldestItemDeliveryTimeStamp);
    }
    else {
        tableView.lastEmptiedTime = new Date();
    }
}
// Add selected items newer than lastEmptiedTime to tombstone list
function tombstoneNotExcludedItems(tableView, rowKeysToExclude) {
    if (rowKeysToExclude == undefined) {
        return;
    }
    var lastUnselectedRowIndex = 0;
    // Find index of last unselected row
    for (var i = 0; i < rowKeysToExclude.length; i++) {
        var index = findIndexByInstanceKey(rowKeysToExclude[i], tableView);
        if (index > lastUnselectedRowIndex) {
            lastUnselectedRowIndex = index;
        }
    }
    // Add all selected rows from index 0 to lastUnselectedRowIndex to tombstone
    var toTombstone = tableView.rowKeys
        .slice(0, lastUnselectedRowIndex)
        .filter(function (key) { return rowKeysToExclude.indexOf(key) == -1; });
    tombstoneOperations.add(toTombstone, tableView.serverFolderId, {
        type: 0 /* OnDeleteNotification */,
    });
}
//# sourceMappingURL=emptyFolderStitch.js.map